export default __webpack_public_path__ + "static/media/Logo.28c56bd4.svg";